import { createFileRoute } from "@tanstack/react-router";

import { CouriersPage } from "../../../features/shipping/couriers-page";

export const Route = createFileRoute("/_app/settings/couriers")({ component: CouriersPage });
